"use client";

import { c as _c } from "react/compiler-runtime";
import { darken, useTheme } from "@mui/material";
import React, { type ReactNode } from "react";
import { MainAppBar } from "#/features/appBar/ui/MainAppBar";
import { usePlaygroundMobileLayout } from "#/features/playground/hooks/usePlaygroundMobileLayout";
import { PageScrollContainer } from "#/shared/ui/templates/PageScrollContainer";
type PlaygroundPageShellProps = {
  children: ReactNode;
};

/**
 * Shared chrome for playground routes: scroll container, background, and app bar.
 * Rendered from playground `layout.tsx` so it persists across loading → page swaps.
 */
export const PlaygroundPageShell: React.FC<PlaygroundPageShellProps> = t0 => {
  const $ = _c(11);
  const {
    children
  } = t0;
  const theme = useTheme();
  const isMobile = usePlaygroundMobileLayout();
  let t1;
  if ($[0] !== isMobile) {
    t1 = isMobile ? {
      overflow: {
        x: "hidden",
        y: "hidden"
      }
    } : {
      scrollbars: {
        autoHide: "scroll"
      },
      overflow: {
        x: "hidden"
      }
    };
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== theme.palette.background.default) {
    t2 = darken(theme.palette.background.default, 0.1);
    $[2] = theme.palette.background.default;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      height: "100vh",
      background: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MainAppBar toolbarVariant="dense" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t1 || $[9] !== t3) {
    t5 = <PageScrollContainer isPage={true} options={t1} style={t3}>{t4}{children}</PageScrollContainer>;
    $[7] = children;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};